import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthRepository } from '../state/auth.repository';

@Injectable()
export class UnauthorizedAccessInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authRepo: AuthRepository
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          return this.logoutAndRedirect(err);
        }
        // return throwError(() => err)
        throw err
      })
    );
  }

  private logoutAndRedirect(err: any): Observable<HttpEvent<any>> {
    this.authRepo.reset()
    this.router.navigateByUrl('/');
    // return throwError(() => err);
    throw err
  }

}
